// Entry point for the build script in your package.json
import "./controllers"
import * as bootstrap from "bootstrap"
import flatpickr from "flatpickr"


document.addEventListener('DOMContentLoaded', function() {
  function updateEndTime() {
    const selectedServiceType = document.querySelector('input[name="booking[service_type_id]"]:checked');
    const startTimeInput = document.querySelector('input[name="booking[start_time]"]');
    const endTimeInput = document.querySelector('input[name="booking[end_time]"]');

    if (selectedServiceType && startTimeInput && startTimeInput.value && endTimeInput) {
      const duration = parseInt(selectedServiceType.dataset.duration);
      const startTime = new Date(startTimeInput.value);
      const endTime = new Date(startTime.getTime() + (duration * 60000) + (480 * 60000)); // Convert minutes to milliseconds

      // Format the date to match the datetime-local input format
      const endTimeFormatted = endTime.toISOString().slice(0, 16);
      endTimeInput.value = endTimeFormatted;

    } else {
      endTimeInput.value = '';
    }
  }

  // Add event listeners for service type and start time changes
  document.querySelectorAll('input[name="booking[service_type_id]"]').forEach(radio => {
    radio.addEventListener('change', updateEndTime);
  });

  const startTimeInput = document.querySelector('input[name="booking[start_time]"]');
  if (startTimeInput) {
    startTimeInput.addEventListener('change', updateEndTime);
  }
});

function initTooltips() {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    if (!bootstrap.Tooltip.getInstance(el)) {
      new bootstrap.Tooltip(el)
    }
  })
}

function initDatetimePickers() {
  document.querySelectorAll("[data-datetime-picker]").forEach((el) => {
    if (el._flatpickr) return

    flatpickr(el, {
      enableTime: true,
      minuteIncrement: 30,
      time_24hr: false,
      allowInput: true,
      altInput: true,
      altFormat: "D, M j Y h:i K",
      dateFormat: "Y-m-d H:i",
      defaultDate: el.value || null,
      minDate: el.dataset.minDate || null
    })
  })
}

function reinitTooltip(el) {
  const existing = bootstrap.Tooltip.getInstance(el)
  if (existing) existing.dispose()
  new bootstrap.Tooltip(el)
}

document.addEventListener("DOMContentLoaded", initTooltips)
document.addEventListener("turbo:load", initTooltips)
document.addEventListener("turbo:frame-load", initTooltips)
document.addEventListener("tooltip:reinit", (e) => reinitTooltip(e.detail.el))
document.addEventListener("DOMContentLoaded", initDatetimePickers)
document.addEventListener("turbo:load", initDatetimePickers)
document.addEventListener("turbo:frame-load", initDatetimePickers)
